"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TranslationScopes = void 0;
var TranslationScopes;
(function (TranslationScopes) {
    TranslationScopes["Bonuses"] = "bonuses";
    TranslationScopes["BonusesCashback"] = "bonuses_cashback";
    TranslationScopes["BonusesReferral"] = "bonuses_referral";
    TranslationScopes["BonusesPromotions"] = "bonuses_promotions";
    TranslationScopes["BonusesPromo2"] = "promo_2";
    TranslationScopes["BonusesPromo3"] = "promo_3";
    TranslationScopes["BonusesPromo4"] = "promo_4";
    TranslationScopes["BonusesPromo5"] = "promo_5";
    TranslationScopes["BonusesPromo6"] = "promo_6";
    TranslationScopes["BonusesPromoAviator"] = "promo_aviator";
    TranslationScopes["BonusPromoCasino"] = "promo_casino";
    TranslationScopes["BonusPromoCasino2"] = "promo_casino_2";
    TranslationScopes["Calendar"] = "calendar";
    TranslationScopes["Casino"] = "casino";
    TranslationScopes["CasinoWidgets"] = "casino_widgets";
    TranslationScopes["CasinoLiveCasino"] = "casino_livecasino";
    TranslationScopes["CasinoPolicies"] = "casino_policies";
    TranslationScopes["CasinoSlots"] = "casino_slots";
    TranslationScopes["Common"] = "common";
    TranslationScopes["Home"] = "home";
    TranslationScopes["Live"] = "live";
    TranslationScopes["Multiview"] = "multiview";
    TranslationScopes["NotFound"] = "not_found";
    TranslationScopes["Policies"] = "policies";
    TranslationScopes["PoliciesPayments"] = "policies_payments";
    TranslationScopes["PoliciesPrivacy"] = "policies_privacy";
    TranslationScopes["PoliciesSportsbook"] = "policies_sportsbook";
    TranslationScopes["PoliciesTerms"] = "policies_terms";
    TranslationScopes["PoliciesResponsibleGaming"] = "policies_responsible_gaming";
    TranslationScopes["PoliciesCookies"] = "policies_cookies";
    TranslationScopes["PoliciesSelfExclusion"] = "policies_self_exclusion";
    TranslationScopes["PoliciesDisputeResolution"] = "policies_dispute_resolution";
    TranslationScopes["PoliciesAntiMoneyLaundering"] = "policies_anti_money_laundering";
    TranslationScopes["PoliciesFairnessRngTesting"] = "policies_fairness_rng_testing";
    TranslationScopes["PoliciesKyc"] = "policies_kyc";
    TranslationScopes["PreMatch"] = "prematch";
    TranslationScopes["SubHeader"] = "sub_header";
    TranslationScopes["WalletWidget"] = "wallet_widget";
    TranslationScopes["UserAccount"] = "user_account";
    TranslationScopes["Cpf"] = "cpf";
    TranslationScopes["PixWallet"] = "pix_wallet";
    TranslationScopes["TolaWallet"] = "tola_wallet";
    TranslationScopes["MultiWallet"] = "multi_wallet";
    TranslationScopes["BetSlip"] = "bet_slip";
    TranslationScopes["Results"] = "results";
    TranslationScopes["Verification"] = "verification";
})(TranslationScopes || (exports.TranslationScopes = TranslationScopes = {}));
//# sourceMappingURL=translation-scopes.js.map